import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
import Sm10010View from "../../Views/Sales/SM10010";
import Snackbar from "../../Components/Snackbar";
import { useNavigate } from "react-router-dom";
function SM10010(props) {
  const navigate = useNavigate(); // Route move api

  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [rowData1, setRowData1] = React.useState([]);
  const [authGroupGridRowData, setAuthGroupGridRowData] = React.useState([]);
  const [authGroupGridRowData1, setAuthGroupGridRowData1] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [changedRowData1, setChangedRowData1] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [selectedRowData1, setSelectedRowData1] = React.useState([]);
  const [modalToggle, setModalToggle] = React.useState(false);
  const [modalToggle1, setModalToggle1] = React.useState(false);

  const [checkInputs, setCheckInputs] = React.useState({
    value1: new Date(),
    value2: "",
    value3: "",
    itemType: "ITEM_TYPE_01",
  });
  const [checkInputs1, setCheckInputs1] = React.useState({
    value1: "",
    value2: "",
  });
  const [inputs, setInputs] = React.useState({
    soNo: "",
    soDt: new Date(),
    comboList: [],
    custCd: "",
    contractNo: "",
    contractDt: "",
    custNm: "",
    soDueDt: new Date(),
    address: "",
    zipCode: "",
    custEmail: "",
    delivCustCd: "",
    plantCd: "",
    delivAddress: "",
    delivZipCode: "",
    delivEmail: "",
    closeYn: "",
    fileName: "",
    filePath: "",
    createId: "",
    remark: "",
    itemCd: "",
    itemNm: "",
    itemStdAmt: "",
    currencyNm: "",
  });
  const [totalInputs, setTotalInputs] = React.useState({
    totalAmt: 1,
    currencyAmt: 1,
    currencyNm: "",
    kTotalAmt: 0,
  });
  const [addEventController, setAddEventController] = React.useState("0");
  const [checkUserIdToggle, setCheckUserIdToggle] = React.useState(false);
  const [checkSoNoToggle, setCheckSoNoToggle] = React.useState(false);
  const [createDate, setCreateDate] = React.useState(new Date());
  const [sonoSave, setSoNoSave] = React.useState("");
  const today = new Date();
  const monthAgo = new Date(today);
  const [startDate, setStartDate] = React.useState(
    monthAgo.setMonth(today.getMonth() - 3)
  );
  const [endDate, setEndDate] = React.useState(new Date());

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    SearchLogic();
  }, []);

  const SearchLogic = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getComboData = [];
    let nowDate = new Date();
    let userInfo = null;
    let expiredTime = false;
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);

      if (expiredTime == true) {
        await Commons.Axios(
          "post",
          Global.serverUrls.useUrl + Global.urls.logic.Common.LogOut,
          {
            userId: userInfo,
          }
        ).then((result) => {
          navigate("/");
          let data = result.data;
        });
      }
      //콤보박스
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetCode,
        {
          groupCd: "string",
        }
      ).then((result) => {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          getComboData.push({
            groupCd: data[i].GroupCd,
            value: data[i].Code,
            name: data[i].Name,
          });
        }
        inputs.comboList = getComboData.filter((e) => e.groupCd == "ITEM_TYPE");
      });

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Sales.SM10010.GetSalesOrders,
        {
          StartDate: new Date(startDate),
          EndDate: new Date(endDate),
        }
      ).then((result) => {
        let data = result.data;

        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setRowData([]);
          setRowData1([]);
        } else if (data.type === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setRowData1([]);
          setRowData([]);
        } else {
          console.log(data);
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              plantCd: data[i].plantCd,
              plantNm: data[i].plantNm,
              soNo: data[i].soNo,
              soDt: data[i].soDt
                ? Commons.DateFormating(data[i].soDt.toString(), 2)
                : "",
              custCd: data[i].custCd,
              custNm: data[i].custNm,
              currencyNm: data[i].currencyNm,
              closeYn: data[i].closeYn,
              remark: data[i].remark,
              updateId: data[i].updateId,
            });
          }
          setRowData(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const GetSalesOrderItemdtls = async (_sono) => {
    Dialog.ProgressBar(true);
    let getRowData = [];
    let totalAmt1 = 0;
    setSoNoSave(_sono);
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Sales.SM10010.GetSalesOrderItemdtls,
        { SoNo: _sono }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setTotalInputs({
            ...totalInputs,
            totalAmt: 1,
            currencyAmt: 1,
          });
          setRowData1([]);
        } else if (data.type === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setRowData1([]);
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              stusNm: data[i].stusNm,
              soNo: data[i].soNo,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemQty: data[i].itemQty,
              soItemCost: data[i].soItemCost,
              soItemAmt: data[i].soItemAmt,
              soItemVat: data[i].soItemVat,
              soDueNo: data[i].soDueNo,
              soDueDt: new Date(data[i].soDueDt),
              custItemCd: data[i].custItemCd,
            });

            totalAmt1 += data[i].soItemAmt;
            setTotalInputs({
              ...totalInputs,
              totalAmt: totalAmt1,
            });
            setRowData1(Commons.InsertNumber(getRowData));
          }
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SaveConfirm = (_type) => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        if (_type === "save") {
          SaveLogic();
        } else {
          SaveItmLogic();
        }
      }
    );
  };

  const SaveLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let updateData = Commons.Deduplication(changedRowData);

    let salesOrders = [];

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Sales.SM10010.CreateSalesOrders,
        [
          {
            plantCd: inputs.plantCd,
            soNo: inputs.soNo,
            soDt: inputs.soDt,
            custCd: inputs.custCd,
            closeYn: inputs.closeYn,
            remark: inputs.remark,
            createId: userInfo.userId,
            createDate: Commons.DateStrChange(new Date()),
            updateId: userInfo.userId,
            updateDate: Commons.DateStrChange(new Date()),
          },
        ]
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            typ: "error",
            message: data,
          });
        } else {
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });
          SearchLogic();
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SaveItmLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    await IndexedDb.GetLoginInfo().then((result) => {
      userInfo = result;
    });
    let updateData = Commons.Deduplication(changedRowData1);
    let ItemData = [];
    let pushData = [];
    let offset = 1000 * 60 * 60 * 9;

    let uniqArr = changedRowData1.filter((item, index) => {
      return changedRowData1.indexOf(item) === index;
    });
    for (let i = 0; i < rowData1.length; i++) {
      if (!rowData1[i].itemQty) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: lanData.filter(
            (f) => f.lanId === "Snack_CheckQty" && f.lanType === "SNACK"
          )[0].lanName,
        });
        Dialog.ProgressBar(false);
        return false;
      }
    }
    try {
      for (let i = 0; i < rowData1.length; i++) {
        if (
          rowData1[i].stusNm == "주문완료" ||
          rowData1[i].stusNm == undefined
        ) {
          pushData.push({
            plantCd: inputs.plantCd,
            soNo: sonoSave,
            itemCd: rowData1[i].itemCd,
            itemQty: rowData1[i].itemQty,
            currencyCd: "",
            soItemCost: rowData1[i].soItemCost,
            soItemVat: rowData1[i].soItemVat,
            soItemAmt: rowData1[i].soItemAmt,
            soDueNo: rowData1[i].soDueNo,
            soDueDt: Commons.DateStrChange(rowData1[i].soDueDt),
            prodPlanDt: Commons.DateStrChange(new Date()),
            stusCd: "",
            delivOrderNo: "",
            cancleYn: "N",
            createId: userInfo.userId,
            createDate: Commons.DateStrChange(new Date()),
            updateId: userInfo.userId,
            updateDate: Commons.DateStrChange(new Date()),
          });
        }
      }
      await Commons.Axios(
        "post1",
        Global.serverUrls.useUrl +
          Global.urls.logic.Sales.SM10010.CreateSalesOrderItemdtls,
        pushData
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          throw new Error(data);
        } else {
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });
          GetSalesOrderItemdtls(sonoSave);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const DeleteConfirm = (_type) => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        if (_type === "Delete") {
          DeleteLogic();
        } else {
          DeleteItemLogic();
        }
      }
    );
  };
  const DeleteLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      for (let i = 0; i < rowData1.length; i++) {
        if (rowData1[i].stusNm == "생산완료") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_AlreadyWork" && f.lanType === "SNACK" //이미 생산되었습니다.
            )[0].lanName,
          });
          return false;
        } else if (
          rowData1[i].stusNm == "출하완료" ||
          rowData1[i].stusNm == "출하" ||
          rowData1[i].stusNm == "납품"
        ) {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_AlreadyOut" && f.lanType === "SNACK" //이미 출하되었습니다.
            )[0].lanName,
          });
          return false;
        }
      }
      for (let i = 0; i < selectedRowData.length; i++) {
        deleteData.push({
          plantCd: selectedRowData[i].plantCd,
          soNo: selectedRowData[i].soNo,
          contractNo: selectedRowData[i].contractNo,
          contractDt: selectedRowData[i].contractDt,
          custCd: selectedRowData[i].custCd,
          custEmail: selectedRowData[i].custEmail,
          delivCustCd: selectedRowData[i].delivCustCd,
          delivEmail: selectedRowData[i].delivEmail,
          closeYn: selectedRowData[i].closeYn,
          fileName: selectedRowData[i].fileName,
          filePath: selectedRowData[i].filePath,
          createId: selectedRowData[i].createId,
          createDate: selectedRowData[i].createDate,
          updateId: selectedRowData[i].updateId,
          updateDate: selectedRowData[i].updateDate,
        });
      }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Sales.SM10010.DeleteSalesOrders,
        deleteData
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          if (data == "생산완료") {
            setSnackbars({
              toggle: true,
              type: "info",
              message: lanData.filter(
                (f) => f.lanId === "Snack_AlreadyWork" && f.lanType === "SNACK" //이미 생산되었습니다.
              )[0].lanName,
            });
            return false;
          } else if (data == "출하") {
            setSnackbars({
              toggle: true,
              type: "info",
              message: lanData.filter(
                (f) => f.lanId === "Snack_AlreadyOut" && f.lanType === "SNACK" //이미 출하되었습니다.
              )[0].lanName,
            });
            return false;
          }
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else {
          SearchLogic();
          setRowData1([]);
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const DeleteItemLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      if (selectedRowData1[0].stusNm == "생산완료") {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) => f.lanId === "Snack_AlreadyWork" && f.lanType === "SNACK" //이미 생산되었습니다.
          )[0].lanName,
        });
        return false;
      } else if (selectedRowData1[0].stusNm === "생산중") {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) => f.lanId === "Snack_DeleteWorkOrder" && f.lanType === "SNACK" //작업지시를 삭제해주세요.
          )[0].lanName,
        });
        return false;
      } else if (
        selectedRowData1[0].stusNm == "출하지시" ||
        selectedRowData1[0].stusNm == "출하" ||
        selectedRowData1[0].stusNm == "납품"
      ) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) => f.lanId === "Snack_AlreadyOut" && f.lanType === "SNACK" //이미 출하되었습니다.
          )[0].lanName,
        });
        return false;
      }
      for (let i = 0; i < selectedRowData1.length; i++) {
        deleteData.push({
          plantCd: selectedRowData1[i].plantCd,
          soNo: selectedRowData1[i].soNo,
          soSeq: selectedRowData1[i].soSeq,
          itemCd: selectedRowData1[i].itemCd,

          soDueDt: Commons.DateStrChange(selectedRowData1[i].soDueDt),
        });
      }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Sales.SM10010.DeleteSalesOrderItemdtls,
        deleteData
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else {
          GetSalesOrderItemdtls(sonoSave);
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const GetCommonCustList = async (_value) => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];
    let getData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetCustList,
        {
          plantCd: "string",
          value: _value === "" ? "string" : _value,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getData.push({
              plantCd: data[i].plantCd,
              plantNm: data[i].plantNm,
              custCd: data[i].custCd,
              custNm: data[i].custNm,
              updateId: userInfo.userNm,
            });
          }
          setAuthGroupGridRowData(getData);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const GetCommonItemList = async (_value) => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];
    let getData = [];
    let totalAmt1 = 0;

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetItemList2,
        {
          custCd: inputs.custCd,
          plantCd: inputs.plantCd,
          itemType: checkInputs.itemType,
          value: _value === "" ? "string" : _value,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setAuthGroupGridRowData1([]);
        } else if (data.type === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setAuthGroupGridRowData1([]);
        } else {
          for (let i = 0; i < data.length; i++) {
            getData.push({
              plantCd: data[i].plantCd,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemStdAmt: data[i].itemStdAmt,
              custItemCd: data[i].custItemCd,
            });
          }
          setAuthGroupGridRowData1(Commons.InsertNumber(getData));
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const Reset = () => {
    setInputs({
      ...inputs,
      soNo: "",
      custCd: "",
      constractNo: "",
      custNm: "",
      address: "",
      zipCode: "",
      custEmail: "",
      elivCustCd: "",
      elivAddress: "",
      elivZipCode: "",
      elivEmail: "",
      remark: "",
      plantNm: "",
      updateId: "",
      soDt: new Date(),
    });
  };
  const ResetHelpForm = () => {
    setInputs({
      ...inputs,
      soNo: "",
      custCd: "",
      constractNo: "",
      custNm: "",
      address: "",
      zipCode: "",
      custEmail: "",
      elivCustCd: "",
      elivAddress: "",
      elivZipCode: "",
      elivEmail: "",
    });
  };

  return (
    <>
      <Sm10010View
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        rowData1={rowData1}
        setRowData1={setRowData1}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        selectedRowData={selectedRowData}
        setSelectedRowData={setSelectedRowData}
        GetSalesOrderItemdtls={GetSalesOrderItemdtls}
        setModalToggle={setModalToggle}
        setModalToggle1={setModalToggle1}
        checkUserIdToggle={checkUserIdToggle}
        checkInputs={checkInputs}
        setCheckUserIdToggle={setCheckUserIdToggle}
        SaveConfirm={SaveConfirm}
        setInputs={setInputs}
        inputs={inputs}
        setCheckInputs={setCheckInputs}
        setCheckInputs1={setCheckInputs1}
        checkInputs1={checkInputs1}
        setCheckSoNoToggle={setCheckSoNoToggle}
        checkSoNoToggle={checkSoNoToggle}
        Reset={Reset}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        DeleteConfirm={DeleteConfirm}
        SearchLogic={SearchLogic}
        setStartDate={setStartDate}
        startDate={startDate}
        setEndDate={setEndDate}
        endDate={endDate}
        GetCommonCustList={GetCommonCustList}
        authGroupGridRowData={authGroupGridRowData}
        authGroupGridRowData1={authGroupGridRowData1}
        setAuthGroupGridRowData={setAuthGroupGridRowData}
        setAuthGroupGridRowData1={setAuthGroupGridRowData1}
        GetCommonItemList={GetCommonItemList}
        SaveItmLogic={SaveItmLogic}
        ResetHelpForm={ResetHelpForm}
        setAddEventController={setAddEventController}
        totalInputs={totalInputs}
        setTotalInputs={setTotalInputs}
        setSelectedRowData1={setSelectedRowData1}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default SM10010;
